/**
 * @desc 扣减库存中心库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.outStock.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/outStock`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
